import { render, staticRenderFns } from "./ListSection.vue?vue&type=template&id=31c974d0&scoped=true"
import script from "./ListSection.vue?vue&type=script&lang=js"
export * from "./ListSection.vue?vue&type=script&lang=js"
import style0 from "./ListSection.vue?vue&type=style&index=0&id=31c974d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c974d0",
  null
  
)

export default component.exports